// src/services/adminStats.js
import { fetchUsers } from "./adminUsers";
import { fetchAllJobs } from "./adminJobs";

// Statuses that count as an active (in-flight) job
const ACTIVE = ["searching", "dispatched", "assigned", "on_the_way", "arrived"];

export async function fetchDashboardStats() {
  const [users, jobs] = await Promise.all([fetchUsers(), fetchAllJobs()]);

  const customers = users.filter((u) => u.role === "customer").length;
  const taskers = users.filter((u) => u.role === "tasker").length;
  const suspended = users.filter((u) => (u.status || "active") === "suspended").length;

  const activeJobs = jobs.filter((j) => ACTIVE.includes(j.status)).length;
  const completedJobs = jobs.filter((j) => j.status === "completed").length;
  const cancelledJobs = jobs.filter((j) => j.status === "cancelled").length;
  const noTaskerJobs = jobs.filter((j) => j.status === "no_tasker").length;

  // Platform-fee revenue = sum of platformFee on completed jobs
  const platformFees = jobs
    .filter((j) => j.status === "completed")
    .reduce((sum, j) => sum + (Number(j.platformFee) || 0), 0);

  return {
    totalUsers: users.length,
    customers,
    taskers,
    suspended,
    totalJobs: jobs.length,
    activeJobs,
    completedJobs,
    cancelledJobs,
    noTaskerJobs,
    platformFees,
  };
}
